// Import: Middleware Action & Custom Types
import {
  CLEAN_IPB_PACKAGE_BY_CHANNEL,
  CLEAN_IPB_PACKAGE_BY_CHANNEL_ERROR,
} from '_models/redux/types';

// Action function
export const cleanIpbPackageByChannelAction = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_IPB_PACKAGE_BY_CHANNEL,
    });
  } catch {
    dispatch({
      payload: undefined,
      type: CLEAN_IPB_PACKAGE_BY_CHANNEL_ERROR,
    });
  }
};
